import { render, staticRenderFns } from "./ExamSelector.vue?vue&type=template&id=1c713668&scoped=true&"
import script from "./ExamSelector.vue?vue&type=script&lang=js&"
export * from "./ExamSelector.vue?vue&type=script&lang=js&"
import style0 from "./ExamSelector.vue?vue&type=style&index=0&id=1c713668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c713668",
  null
  
)

export default component.exports